import React from "react";
import { useParams } from "react-router-dom";
import styles from "../WeeklyReview.module.scss";
import { Typography } from "@material-ui/core";
import NotesButton from "../../../components/Notes/NotesButton";

const CustomerUpdate = () => {
  const params = useParams();
  return (
    <>
      <Typography variant="h4" align="center">
        Any customer updates?
      </Typography>
      <Typography variant="h5" align="center" className={styles.flexCenter}>
        Notes:
        <NotesButton id={params.meeting_id} core="customerUpdate" model="meeting" size={1.25} />
      </Typography>
    </>
  );
};

export default CustomerUpdate;
